
var VersionManager = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014",
      debug,
      editionId,
      versionId,
      cache = {
        endpoint: null,
        editions: {},
        referenceSets: {},
        valueSets: null,
      },
      theTimeout,
      listeners = [];

  return {
    settings: {
      versionSelector: null,
      systemURI: null,
      versionURI: null,
    },

    init: function (flag) {
      var s = this.settings;
      debug = function() {
        if (flag) console.error.apply(this, arguments);
      }
      debug('VersionManager.init');

      versionId = s.versionSelector;

      return;
    },

    getCodeSystems: function() {
      var cs = values(cache.editions)
               .sort(function (a,b) {
                 if (a.id === b.id) return 0;
                 if (a.id === 'http://snomed.info/sct') return -1;
                 if (b.id === 'http://snomed.info/sct') return 1;
                 if (a.id === 'http://loinc.org') return -1;
                 if (b.id === 'http://loinc.org') return 1;
                 return a.name.localeCompare(b.name, 'en', {'sensitivity': 'base', 'numeric': true, 'ignorePunctuation': true});
               });
      return cs;
    },

    getCodeSystemValueSet: function(codesystem, version) {
      if (version) {
        var vs = (cache.editions[codesystem].versions || [])
                   .filter(function (v) { return version === v.id; });
        if (vs.length > 0) {
          return vs[0].valueset;
        } else {
          return undefined;
        }
      } else {
        return (cache.editions[codesystem] || {}).valueset;
      }
    },

    getVersions: function(codeSystem) {
      var cs = cache.editions[codeSystem];
      return cs ? cs.versions : [];
    },

    setEndpoint: function(url) {
      debug('VersionManager.setEndpoint', url);
      if (url === cache.endpoint) {
        return;
      }
      clearCache(url);

      Endpoint.getVersions(null, function(error, data) {
        if (error || !data) {
          console.log('status', error && error.status);
          console.log('error', error);
          console.log('data', data);
          // alert("Ontoserver getVersions failed: " + error.responseText);
          return;
        }

        cache.editions = {};

        data
          .filter(function (ext) {
            // just those that are complete, have a default ValueSet defined, and that have a hierarchyMeaning
            var res = ext.resource;
            if (res.url
                  && res.valueSet
                  // && (res.hierarchyMeaning || res.url === 'http://snomed.info/sct' || res.url === 'http://loinc.org')
                  // && 'example' !== res.content && 'exemplar' !== res.content && 'fragment' !== res.content
                  ) {
              return res.url === 'http://hl7.org/fhir/sid/icd-10' ||
                     res.url === 'http://snomed.info/sct' ||
                     res.url === 'http://loinc.org' ||
                     res.url === 'http://id.who.int/icd11/mms' ||
                     res.url === 'http://id.who.int/icd11/foundation' ||
                     res.url === 'http://purl.obolibrary.org/obo/hp.owl' ||
                     true || // Be more generous :)  (res.filter||[]).find(function (p) { return p.code === "parent" && p.operator && p.operator.indexOf('exists') >= 0; }) ||
//                     (res.filter||[]).find(function (p) { return (p.code === "constraint" || p.code === "expression") && p.operator && p.operator.indexOf('=') >= 0; }) ||
                     false;
            } else {
              return false;
            }
          })
          .forEach(function (ext, k) {
            var res = ext.resource,
                id = res.url,
                vers = res.version,
                content = res.content,
                name = res.title || res.name,
                date = res.date,
                vs = res.valueSet || {
                  "resourceType": "ValueSet",
                  "compose": {
                    "include": [{
                      "system": id,
                      "version": vers
                    }]
                  }
                };

            if (content !== 'complete') {
              name = name + ' (' + content + ')';
            }

            cache.editions[id] = cache.editions[id] ||
                           { id: id,
                             versions: [
                              // {id: '', valueset:vs, name: name, vers: 'unspecified version'}
                             ],
                           };
            if (vers) {
              var versionName = vers;
              if (vers.indexOf('http://snomed.info/sct') === 0 || vers.indexOf('http://snomed.info/xsct') === 0) {
                var offset = vers.length - 8;
                var edition = vers.substring(vers.indexOf('sct/')+4, offset - 9);
                var effectiveTime = vers.substring(offset);
                var skipExtension = false;

                if (vers.indexOf('/32506021000036107/') > 0) {
                  versionName = '🇦🇺 AU';
                } else if (vers.indexOf('/21000032107/') > 0) {
                  versionName = '🇦🇺 PAH';
                } else if (vers.indexOf('/999000031000000106/') > 0) {
                  versionName = '🇬🇧 UK Edition (historical)';
                } else if (vers.indexOf('/999000021000000109/') > 0) {
                  versionName = '🇬🇧 UK Clinical (historical)';
                } else if (vers.indexOf('/83821000000107/') > 0) {
                  versionName = '🇬🇧 UK';
                //} else if (vers.indexOf('/999000041000000102/') > 0) {
                //  versionName = '🇬🇧 UK';
                } else if (vers.indexOf('/999000011000001104/') > 0) {
                  versionName = '🇬🇧 UK Drugs (historical)';
                  skipExtension = true;
                } else if (vers.indexOf('/999991001000101/') > 0) {
                  versionName = 'IPS';
                  skipExtension = true;
                } else if (vers.indexOf('/900000000000207008/') > 0) {
                  versionName = 'International';
                } else if (vers.indexOf('/731000124108/') > 0) {
                  versionName = '🇺🇸 US';
                } else if (vers.indexOf('/11000221109/') > 0) {
                  versionName = '🇦🇷 Argentina';
                } else if (vers.indexOf('/11000234105/') > 0) {
                  versionName = '🇦🇹 Austria';
                } else if (vers.indexOf('/11000172109/') > 0) {
                  versionName = '🇧🇪 Belgium';
                } else if (vers.indexOf('/554471000005108/') > 0) {
                  versionName = '🇩🇰 Denmark';
                } else if (vers.indexOf('/11000181102/') > 0) {
                  versionName = '🇪🇪 Estonia';
                } else if (vers.indexOf('/11000315107/') > 0) {
                  versionName = '🇫🇷 France';
                } else if (vers.indexOf('/11000274103/') > 0) {
                  versionName = '🇩🇪 Germany';
                } else if (vers.indexOf('/11000220105/') > 0) {
                  versionName = '🇮🇪 Ireland';
                } else if (vers.indexOf('/1601000220105/') > 0) {
                  versionName = '🇮🇪 Ireland Drugs';
                } else if (vers.indexOf('/1303956008/') > 0) {
                  versionName = '🍱 NCPT';
                } else if (vers.indexOf('/51000202101/') > 0) {
                  versionName = '🇳🇴 Norway';
                } else if (vers.indexOf('/5631000179106/') > 0) {
                  versionName = '🇺🇾 Uruguay';
                } else if (vers.indexOf('/449081005/') > 0) {
                  versionName = 'Spanish';
                } else if (vers.indexOf('/900000001000122104/') > 0) {
                  versionName = '🇪🇸 Extensión España';
                } else if (vers.indexOf('/450829007/') > 0) {
                  versionName = '🌎 Latinoamérica';
                } else if (vers.indexOf('/11000146104/') > 0) {
                  versionName = '🇳🇱 Netherlands';
                } else if (vers.indexOf('/15561000146104/') > 0) {
                  versionName = '🇳🇱 Netherlands patient-friendly';
                } else if (vers.indexOf('/45991000052106/') > 0) {
                  versionName = '🇸🇪 Sweden';
                } else if (vers.indexOf('/2011000195101/') > 0) {
                  versionName = '🇨🇭 Switzerland';
                } else if (vers.indexOf('/20611000087101/') > 0) {
                  versionName = '🇨🇦 CA';
                } else if (vers.indexOf('/21000210109/') > 0) {
                  versionName = '🇳🇿 NZ';
                } else if (vers.indexOf('/332351000009108/') > 0) {
                  versionName = '🐎 Veterinary';
                } else {
                  console.log('Unrecognized SNOMED Edition', vers);
                  versionName = 'Unknown ' + edition;
                }

                if (vers.indexOf('http://snomed.info/xsct') === 0 && !skipExtension) {
                  versionName = versionName + ' (Experimental)';
                }

                versionName = versionName + ' - ' + effectiveTime;
              }
              cache.editions[id].versions.push({id: vers, valueset: vs, name: name, date: date, vers: versionName});
              cache.editions[id].valueset = vs;
            } else {
              cache.editions[id].name = name;
              cache.editions[id].date = date;

              cache.editions[id].versions.push({id: '', valueset: vs, name: name, date: date, vers: '-'});
              cache.editions[id].valueset = vs;
            }
          });

        Object.keys(cache.editions)
          .forEach(function (id) {
            var sortFn = function (a,b) { return a.id < b.id ? 1 : (b.id < a.id ? -1 : 0); };
            if (id === 'http://snomed.info/sct') {
              sortFn = function (a,b) {
                if (a.vers && b.vers) {
                  var af = stripFlags(a.vers.split('-')),
                      bf = stripFlags(b.vers.split('-'));
                  return af[0] < bf[0] ? -1 : (bf[0] < af[0] ? 1 : 
                           (af[1] < bf[1] ? 1 : (bf[1] < af[1] ? -1 : 0)));
                }
                if (!a.id) return -1;
                if (!b.id) return 1;
                var af = a.id.split('/'),
                    bf = b.id.split('/');
                return af[4] < bf[4] ? -1 : (bf[4] < af[4] ? 1 : 
                         (af[6] < bf[6] ? 1 : (bf[6] < af[6] ? -1 : 0)));
              };

              var defaultVersions = {};
              cache.editions[id]
                .versions
                .forEach(function (v) { defaultVersions[v.id.replace(/\/version\/.*/, '')] = v.vers; });
              Object.keys(defaultVersions)
                .forEach(function (v) {
                  cache.editions[id].versions.push({id: v, valueset: v+'?fhir_vs', name: name, vers: defaultVersions[v].replace(/ - .*/, ' - Latest')});
                });
            }

            cache.editions[id]
              .versions
              .sort(sortFn);
            if (cache.editions[id].versions[0]) {
              if(id === 'http://snomed.info/sct')
                cache.editions[id].name = "SNOMED CT";
              else if(id === 'http://loinc.org')
                cache.editions[id].name = "LOINC";
              else if(id === 'http://hl7.org/fhir/sid/icd-10')
                cache.editions[id].name = "ICD-10";
              else
                cache.editions[id].name = (cache.editions[id].versions[0].name || id);

              if(id.startsWith('http://id.who.int/icd11'))
                cache.editions[id].name = cache.editions[id].name + ' - LIMITED USE'
            }
          });

        listeners.forEach(function (callback) {
          try {
            callback(url);
          } catch (err) {
          console.log(err);
          }
        });

      });
    },

    getConceptMaps: function (cb) {
      Endpoint.find({
          'type': 'ConceptMap',
        }, function (error,data) {
          if (error) {
            console.log('error', error);
            cb([]);
            return;
          }
          var results = data.map(function (e) {
            return e.resource;
          });
          cb(results);
        });
    },

    getReferenceSets: function (systemURI, versionURI, cb) {
      var cacheKey = systemURI + '|' + versionURI;
      if (cache.referenceSets[cacheKey]) {
        cb(cache.referenceSets[cacheKey]);
      } else if ('http://snomed.info/sct' === systemURI) {
        var key = (versionURI||systemURI)+"?fhir_vs=refset";
        return Endpoint.expand({url: key}, function (error,data) {
          if (error) {
            console.log('error', error);
            cb([]);
            return;
          }
          cache.referenceSets[cacheKey] =
            // [{id:currentValueSet, label:' All Codes', }]
              [].concat((data.contains || []).map(function (concept) { return { id: key+"/"+concept.code, label: concept.display, }; }));
          cb(cache.referenceSets[cacheKey]);
        });
      } else {
        cache.referenceSets[cacheKey] = []; //[{id:currentValueSet, label:'All Codes', }];
        cb(cache.referenceSets[cacheKey]);
      }
    },

    getValueSets: function (cb) {
      if (cache.valueSets) {
        cb(cache.valueSets);
      } else {
        return Endpoint.find({type: 'ValueSet', elements: 'id,url,title,name,date,description,publisher,version'}, function (error,data) {
          if (error) {
            console.log('error', error);
            cb([]);
            return;
          }
          cache.valueSets =
            [
              // { id: ' ', label: ' ALL KNOWN CODES ', url: 'http://hl7.org/fhir/ValueSet/@all', description: 'All value sets (codes) known to the server.', publisher: 'HL7' }
            ].concat(
              (data || [])
               .map(function (entry) { var r = entry.resource; return { id: r.id, label: r.title || r.name || r.id, url: r.url, version: r.version, date: r.date, description: r.description, publisher: r.publisher }; })
            );
          cb(cache.valueSets);
        });
      }
    },
    
    addListener: function (listener) { listeners.push(listener); },
    removeListener: function (listener) {
      const idx = listeners.indexOf(listener);
      if (idx >= 0) {
        return listeners.splice(idx, 1)
      } else {
        return []
      }
    }
  };

  function values(dictionary) {
    return Object.keys(dictionary).map(function(key) {
      return dictionary[key];
    });
  }

  function clearCache(url) {
    cache = {
      endpoint: url,
      editions: {},
      referenceSets: {},
      valueSets: null,
    };
  }

  function stripFlags(strs) {
    strs[0] = strs[0].replace(/^([^\x00-\x7F]| )*/, '');
    return strs;
  }

}());

